export default "__VITE_ASSET__DLYIatCD__"